import alt from '../alt';
import Immutable from 'seamless-immutable';
import {seamlessImmutable} from 'epic-alt-utils/index';

@seamlessImmutable
class StatsStore {
    constructor() {
        this.on('error', (error) => {console.error(error);});
        this.state = Immutable({
            playerStats: null
        });
    }
}

export default alt.createStore(StatsStore, 'StatsStore');
